<template>
  <div class="flex-wrapper-app">
    <Navbar />
    <div class="merchantdrop-container-main">
      <div class="container" v-if="isOrderMerchantDropoffEligible">
        <div v-if="isSuccess === true">
          <MerchantDropoffSuccess :barcodeId="this.barcodeId" :reason="other" />
        </div>
        <div v-else-if="isSuccess === false">
          <MerchantDropoffFail :barcodeId="this.barcodeId" :reason="errorMessage" />
        </div>
        <div v-else>
          <h2 class="merchantdrop-title">{{ $t('merchantDropoff.title') }}</h2>
          <br />
          <div
            :class="[
              'merchantdrop-main-container',
              { 'merchantdrop-main-container-loading': isLoading },
            ]"
          >
            <div :class="['loader-overlay', { 'loader-overlay-hide': !isLoading }]">
              <Loader />
            </div>
            <div class="font-size-20">
              <div class="merchantdrop-map-header-container">
                <div>
                  <h3>
                    {{ $t('merchantDropoff.initialOrder') }}
                    <strong class="font-weight-bold">{{ barcodeId }}</strong>
                  </h3>
                  <!-- <h3 class="margin-top-5"> -->
                  <div class="phone-number-container">
                    <h3 class="margin-top-5">
                      {{ $t('merchantDropoff.mobilePhone') }}
                    </h3>
                    <div class="select is-primary is-rounded prefix-select">
                      <select name="countryPrefix" v-model="selectedPrefix">
                        <option
                          v-for="{ code, prefix } in countryPrefixes"
                          :key="code"
                          :value="prefix"
                        >
                          {{ `${code} (${prefix})` }}
                        </option>
                      </select>
                    </div>
                    <input
                      class="input is-primary is-rounded phone-input"
                      type="text"
                      name="phoneText"
                      placeholder="New Phone"
                      v-model="updatePhone"
                      @keydown.enter="updatePhoneNumber"
                    />
                    <button @click="updatePhoneNumber">Update 📞</button>
                  </div>
                  <div
                    v-if="
                      (updatePhone !== phoneNumber || selectedPrefix !== prefix) &&
                        invalidPhoneNumber === false
                    "
                  >
                    <p class="warning-text">{{ $t('merchantDropoff.updateWarning') }}</p>
                  </div>
                  <!-- </h3> -->
                </div>
                <div class="flex-end">
                  <h4 class="information-container">
                    <div class="info-icon-margin">
                      <img
                        src="../../../assets/images/info-icon.svg"
                        alt="search-icon"
                        width="24"
                        height="24"
                      />
                    </div>
                    <span class="font-weight-bold"
                      >{{ $t('merchantDropoff.phoneLinkedInfo', { phone: prefix + phoneNumber }) }}
                    </span>
                  </h4>
                </div>
              </div>
              <div v-if="invalidPhoneNumber" class="invalid-banner">
                {{ $t('merchantDropoff.invalidPhoneMessage') }}
              </div>
              <div class="merchantdrop-grid-table">
                <h3>
                  {{ $t('merchantDropoff.selectPointLabel') }}
                </h3>

                <button @click="showMap = true && isMobile" class="show-map-button">
                  {{ $t('merchantDropoff.showPointsButton') }}
                </button>

                <div v-show="showMap || !isMobile" class="popup-place-slm-map-container">
                  <div class="popup-place-slm-map" style="text-align:right">
                    <span class="closeMapBtn" @click="closeMap" v-if="isMobile">ⓧ</span>
                    <div id="skroutzLockerMap" class="merchantdrop-map"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :class="[
                'margin-top-10',
                {
                  invisible: !(
                    merchantDropoffExternalId &&
                    merchantDropoffLockerFriendlyName &&
                    merchantDropofLockerAddress &&
                    !isLoading
                  ),
                },
              ]"
            >
              <p class="merchantdrop-selected-locker-message">
                {{ $t('merchantDropoff.selectedPointPrefix') }}
                <strong class="merchantdrop-selected-highlight">{{
                  merchantDropoffLockerFriendlyName
                }}</strong>
                {{ $t('merchantDropoff.atAddress') }}
                <strong class="merchantdrop-selected-highlight">{{
                  merchantDropofLockerAddress
                }}</strong>
              </p>
              <div class="slot-size-container">
                <h3 class="font-size-20">
                  {{ $t('merchantDropoff.selectSizeLabel') }}
                </h3>
                <br />

                <button-selector
                  :availableSlotSizes="this.availableSlotSizes"
                  @buttonSelected="handleButtonSelected"
                  ref="buttonSelector"
                ></button-selector>

                <br />
                <div v-if="selectedButton" class="font-size-16" style="text-align: start">
                  <p class="margin-top-16 font-size-16">
                    {{ $t('merchantDropoff.selectedSizeLabel') }}
                    <b class="font-weight-bold">{{ selectedButton.nameGreek }}</b
                    >.
                  </p>

                  {{ $t('merchantDropoff.dimensionsLabel') }}
                  <b class="font-weight-bold">{{ selectedButton.dimensions }}</b>
                </div>
              </div>
              <div class="bottom-buttons-container">
                <div>
                  <button
                    :class="[
                      'merchantdrop-confirm-button',
                      { 'disable-confirm-button': disableConfirmBtn || invalidPhoneNumber },
                    ]"
                    @click="confirmOrder"
                    :disabled="disableConfirmBtn || invalidPhoneNumber"
                  >
                    {{ $t('merchantDropoff.confirmButton') }}
                  </button>
                  <p class="merchantdrop-confirm-button-sub-text">
                    {{ $t('merchantDropoff.confirmSubText') }}
                  </p>
                </div>
                <div v-if="showCallSupportBtn">
                  <a href="tel:+2111982107" style="">
                    <button class="call-support-button">
                      {{ $t('merchantDropoff.callSupportButton') }}
                    </button>
                  </a>
                  <p class="merchantdrop-confirm-button-sub-text">
                    {{ $t('merchantDropoff.callSupportSubText') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-else>
        <div :class="['loader-overlay', { 'loader-overlay-hide': !isLoading }]">
          <Loader />
        </div>
        <h4 class="merchantdrop-title">
          {{ errorMessage ? errorMessage : $t('merchantDropoff.somethingWentWrong') }}
        </h4>
        <br style="margin: 80px 0 30px 0;" />
        <div class="bottom-buttons-container">
          <div>
            <a href="tel:+2111982107" class="call-support-button-wrapper">
              <button class="call-support-button">
                {{ $t('merchantDropoff.callSupportButton') }}
              </button>
            </a>
            <p style="margin-top: 6px; max-width: 400px">
              {{ $t('merchantDropoff.errorSupportText') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from 'axios';

import Navbar from '../../pages-sections/Navbar.vue';
import Footer from '../../pages-sections/Footer.vue';
import MerchantDropoffSuccess from '../../pages/MerchantDropoff/MerchantDropoffSuccess.vue';
import MerchantDropoffFail from '../../pages/MerchantDropoff/MerchantDropoffFail.vue';
import Loader from '../../loader/Loader.vue';
import ButtonSelector from './ButtonSelector.vue';
export default {
  name: 'MerchantDropoff',
  components: {
    Navbar,
    Footer,
    Loader,
    MerchantDropoffSuccess,
    MerchantDropoffFail,
    ButtonSelector,
  },
  data() {
    return {
      isOrderMerchantDropoffEligible: true,
      barcodeId: '',
      isLoading: false,
      isSuccess: null,
      merchantDropoffExternalId: '',
      merchantDropoffLockerFriendlyName: '',
      merchantDropofLockerAddress: '',
      phoneNumber: '',
      errorMessage: '',
      availableSlotSizes: [],
      selectedButton: null,
      disableConfirmBtn: true,
      showCallSupportBtn: false,
      showMap: false,
      isMobile: false,
      prefix: '',
      updatePhone: '', // Set the default value to phoneNumber
      selectedPrefix: '', // Default prefix
      invalidPhoneNumber: false,
      countryPrefixes: [
        { code: 'GR', prefix: '+30' },
        { code: 'CY', prefix: '+357' },
        { code: 'AL', prefix: '+355' },
        { code: 'BG', prefix: '+359' },
        { code: 'GE', prefix: '+995' },
        { code: 'IT', prefix: '+39' },
        { code: 'RU', prefix: '+7' },
        { code: 'TR', prefix: '+90' },
        { code: 'GB', prefix: '+44' },
        { code: 'DE', prefix: '+49' },
        { code: 'FR', prefix: '+33' },
        { code: 'ES', prefix: '+34' },
        { code: 'US', prefix: '+1' },
        { code: 'PT', prefix: '+351' },
        { code: 'NL', prefix: '+31' },
        { code: 'BE', prefix: '+32' },
        { code: 'GI', prefix: '+350' },
        { code: 'LU', prefix: '+352' },
        { code: 'IE', prefix: '+353' },
        { code: 'IS', prefix: '+354' },
        { code: 'MT', prefix: '+356' },
        { code: 'FI', prefix: '+358' },
        { code: 'HU', prefix: '+36' },
        { code: 'LT', prefix: '+370' },
        { code: 'LV', prefix: '+371' },
        { code: 'EE', prefix: '+372' },
        { code: 'MD', prefix: '+373' },
        { code: 'AM', prefix: '+374' },
        { code: 'BY', prefix: '+375' },
        { code: 'AD', prefix: '+376' },
        { code: 'MC', prefix: '+377' },
        { code: 'SM', prefix: '+378' },
        { code: 'VA', prefix: '+379' },
        { code: 'UA', prefix: '+380' },
        { code: 'RS', prefix: '+381' },
        { code: 'ME', prefix: '+382' },
        { code: 'XK', prefix: '+383' },
        { code: 'HR', prefix: '+385' },
        { code: 'SI', prefix: '+386' },
        { code: 'BA', prefix: '+387' },
        { code: 'MK', prefix: '+389' },
        { code: 'RO', prefix: '+40' },
        { code: 'CH', prefix: '+41' },
        { code: 'CZ', prefix: '+420' },
        { code: 'SK', prefix: '+421' },
        { code: 'LI', prefix: '+423' },
        { code: 'AT', prefix: '+43' },
        { code: 'DK', prefix: '+45' },
        { code: 'SE', prefix: '+46' },
        { code: 'NO', prefix: '+47' },
        { code: 'PL', prefix: '+48' },
        { code: 'AZ', prefix: '+994' },
      ],
    };
  },
  mounted() {
    this.barcodeId = this.$route.params?.barcodeId;
    this.handleHashedBarcode(this.barcodeId);
    this.checkViewportWidth();
    window.addEventListener('resize', this.checkViewportWidth);
  },
  methods: {
    async updatePhoneNumber() {
      // Validation check for phone number and update the phone number and prefix
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_COURIER_API}/user/merchantDropoff/validatePhoneNumber`,
          {
            voucherHashed: this.$route.params.barcodeId,
            mobilePhone: `${this.selectedPrefix}${this.updatePhone}`,
          },
        );
        if (response.status === 200) {
          if (response.data.isValid) {
            this.phoneNumber = this.updatePhone;
            this.prefix = this.selectedPrefix;
            this.invalidPhoneNumber = false;
          } else {
            this.invalidPhoneNumber = true;
          }
        }
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.description ?? this.$t('merchantDropoff.somethingWentWrong');
        this.isOrderMerchantDropoffEligible = false;
      } finally {
        this.isLoading = false;
      }
    },
    checkViewportWidth() {
      this.isMobile = window.innerWidth < 800;
    },
    async handleHashedBarcode(hashedBarcode) {
      try {
        this.isLoading = true;
        const response = await axios.post(
          `${process.env.VUE_APP_COURIER_API}/user/merchantDropoff/validateHash`,
          {
            voucherHashed: hashedBarcode,
          },
        );
        if (response.status === 200) {
          this.barcodeId = response.data.barcode;
          this.phoneNumber = response.data.phone;
          this.selectedPrefix = response.data.prefix;
          this.prefix = response.data.prefix;
          this.updatePhone = response.data.phone;
          this.isOrderMerchantDropoffEligible = true;
          this.errorMessage = '';
          this.initMap();
        } else {
          this.errorMessage = this.$t('merchantDropoff.somethingWentWrong');
          this.isOrderMerchantDropoffEligible = false;
        }
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.description ?? this.$t('merchantDropoff.somethingWentWrong');
        this.isOrderMerchantDropoffEligible = false;
      } finally {
        this.isLoading = false;
      }
    },
    async confirmOrder() {
      if (window.confirm(this.$t('merchantDropoff.confirmDialog'))) {
        try {
          this.isLoading = true;
          const response = await axios.post(
            `${process.env.VUE_APP_COURIER_API}/user/merchantDropoff/finalize`,
            {
              voucherHashed: this.$route.params.barcodeId,
              lockerSelected: this.merchantDropoffExternalId,
              slotSizeSelected: this.selectedButton.size,
              mobilePhone: `${this.prefix}${this.phoneNumber}`,
            },
          );
          if (response.status === 200) {
            this.isSuccess = true;
          } else {
            this.isSuccess = false;
          }
        } catch (error) {
          this.errorMessage = error.response.data.description ?? 'unknown';
          this.isSuccess = false;
        } finally {
          this.isLoading = false;
        }
      }
    },
    initMap() {
      var _skroutzPointsMapWidgetOptions = {
        partnerId: 'skou',
        language: 'el',
        type: 'iframe',
        parentElement: '#skroutzLockerMap',
        viewType: 'dropoff',
        afterSelect: selected => {
          if (selected?.id) {
            this.merchantDropoffExternalId = selected.id;
            this.merchantDropoffLockerFriendlyName = selected.name;
            this.merchantDropofLockerAddress = `${selected.street_name} ${selected.street_number}, ${selected.city} ${selected.zip} `;

            if (selected?.model === 'Cleveron') {
              this.availableSlotSizes = [
                {
                  size: 'XS',
                  nameGreek: this.$t('merchantDropoff.sizeXS'),
                  dimensions: this.$t('merchantDropoff.dimensionsFormat', { h: 12, w: 20, d: 62 }),
                },
                {
                  size: 'S',
                  nameGreek: this.$t('merchantDropoff.sizeS'),
                  dimensions: this.$t('merchantDropoff.dimensionsFormat', { h: 12, w: 40, d: 62 }),
                },
                {
                  size: 'M',
                  nameGreek: this.$t('merchantDropoff.sizeM'),
                  dimensions: this.$t('merchantDropoff.dimensionsFormat', { h: 20, w: 40, d: 62 }),
                },
                {
                  size: 'L',
                  nameGreek: this.$t('merchantDropoff.sizeL'),
                  dimensions: this.$t('merchantDropoff.dimensionsFormat', { h: 38, w: 40, d: 62 }),
                },
                {
                  size: 'XL',
                  nameGreek: this.$t('merchantDropoff.sizeXL'),
                  dimensions: this.$t('merchantDropoff.dimensionsFormat', { h: 60, w: 40, d: 62 }),
                },
              ];
            } else {
              this.availableSlotSizes = [
                {
                  size: 'S',
                  nameGreek: this.$t('merchantDropoff.sizeS'),
                  dimensions: this.$t('merchantDropoff.dimensionsFormat', { h: 11, w: 44, d: 59 }),
                },
                {
                  size: 'M',
                  nameGreek: this.$t('merchantDropoff.sizeM'),
                  dimensions: this.$t('merchantDropoff.dimensionsFormat', { h: 24, w: 44, d: 59 }),
                },
                {
                  size: 'L',
                  nameGreek: this.$t('merchantDropoff.sizeL'),
                  dimensions: this.$t('merchantDropoff.dimensionsFormat', { h: 50, w: 44, d: 59 }),
                },
              ];
            }
            this.availableSlotSizes.push({
              size: 'none',
              nameGreek: this.$t('merchantDropoff.sizeNone'),
              dimensions: '-',
            });
          } else if (selected === null) {
            this.merchantDropoffExternalId = '';
            this.merchantDropoffLockerFriendlyName = '';
            this.merchantDropofLockerAddress = '';

            this.availableSlotSizes = [];

            this.resetButtonSelector();
          }
        },
      };
      window._skroutzPointsMapWidgetOptions = _skroutzPointsMapWidgetOptions;

      (function(d) {
        var e = d.createElement('script');
        e.src = `${process.env.VUE_APP_MAP}`;
        e.async = true;
        e.defer = true;
        d.getElementsByTagName('head')[0].appendChild(e);
      })(document);
    },
    handleButtonSelected(button) {
      this.selectedButton = button;

      if (button.size !== 'none') {
        this.disableConfirmBtn = false;
        this.showCallSupportBtn = false;
      } else {
        this.disableConfirmBtn = true;
        this.showCallSupportBtn = true;
      }
    },
    resetButtonSelector() {
      this.$refs.buttonSelector.resetSelection();

      this.disableConfirmBtn = true;
      this.showCallSupportBtn = false;
    },
    closeMap() {
      this.showMap = false;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkViewportWidth);
  },
};
</script>

<style scoped lang="scss">
.merchantdrop-title {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 26px;
}

.merchantdrop-description-text {
  display: inline-block;
  font-size: 22px;
  background-color: #8f6eff;
  color: #dbdbdb;
  border: 1px solid black;
  border-radius: 10px;
  padding: 10px;
  line-height: 100%;
}

.merchantdrop-header,
.merchantdrop-state {
  width: 100%;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 20px;
  border-radius: 10px;
}

.merchantdrop-main-container-loading {
  pointer-events: none;
  background: black;
  opacity: 30%;
}

.merchantdrop-grid-table {
  display: grid;
  grid-template-columns: 100%;
  gap: 10px;
  margin-top: 15px;
}

.merchantdrop-map {
  height: 600px;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
}

.merchantdrop-title-col {
  font-weight: bold;
}

.merchantdrop-selected-locker-message {
  background-color: #f68b24;
  font-size: 16px;
  padding: 6px;
  line-height: 150%;
  text-align: center;
  color: white;
}

.merchantdrop-selected-highlight {
  font-weight: 700;
  color: white;
}

.bottom-buttons-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.merchantdrop-confirm-button {
  min-width: 150px;
  padding: 8px;
  font-size: 26px;
  text-align: center;
  background-color: #279a00;
  &:hover {
    background-color: green;
  }
  height: 55px;
}

.disable-confirm-button {
  cursor: not-allowed;
  background-color: #343c31;
  &:hover {
    background-color: #343c31;
  }

  color: grey;
}

.merchantdrop-confirm-button-main-text {
}
.merchantdrop-confirm-button-sub-text {
  font-size: 12px;
  color: #000;
  width: 150px;
  margin-top: 1px;
  min-height: 100px;
}

.call-support-button {
  min-width: 150px;
  padding: 8px;
  font-size: 20px;
  height: 55px;
  text-align: center;
  background-color: #f68b24;
  &:hover {
    background-color: #f4a154;
  }
}

.call-support-button-wrapper {
  display: inline-block; /* Only take as much width as needed */
  text-decoration: none;
}

.show-map-button {
  display: none;
  margin: 20px 0;
}

@media screen and (max-width: 800px) {
  .merchantdrop-confirm-button {
    font-size: 22px;
    width: 150px;
    height: 60px;
  }
  .call-support-button {
    font-size: 18px;
    height: 60px;
  }

  .show-map-button {
    align-items: center;
    border: 2px solid #111111;
    border-radius: 4px;
    box-sizing: border-box;
    color: #111111;
    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 16px;
    height: 60px;
    position: relative;
    text-align: center;
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    font-weight: 700;
    margin: 20px 8px;

    padding: 10px 20px;
    font-size: 20px;
    background-color: #ffffff;
    width: 200px;
  }

  .show-map-button:after {
    background-color: #e07f00;
    border-radius: 4px;
    content: '';
    display: block;
    height: 58px;
    left: -2px;
    width: 100%;
    position: absolute;
    top: -2px;
    transform: translate(8px, 8px);
    transition: transform 0.2s ease-out;
    z-index: -1;
  }

  .show-map-button:hover {
    background-color: #ffcc79;
  }

  .show-map-button:hover:after {
    transform: translate(0, 0);
  }

  .show-map-button:active {
    background-color: #ffdeda;
    outline: 0;
    font-weight: 400;
  }

  .popup-place-slm-map-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 19997;
  }

  .popup-place-slm-map {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    transform: none;
    background-color: rgba(0, 0, 0, 0.5);
    padding-top: 20px;
  }
  .closeMapBtn {
    font-size: 50px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    z-index: 20000;
    color: #f3b645;
  }

  .merchantdrop-map {
    height: 100vh;
  }
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  cursor: wait;
}

.loader-overlay-hide {
  display: none;
}

.merchantdrop-container {
  background-repeat: repeat no-repeat !important;
}

.merchantdrop-container-main {
  flex-grow: 1;
  display: flex;
  background: url('../../../assets/images/graphic-bg-tracking.svg');
  background-repeat: no-repeat !important;
  background-position: center bottom;
}

h4 {
  width: 490px;
  font-size: 16px;
  font-weight: normal;
  color: rgb(54, 54, 54);
  line-height: 26px;
}

.information-container {
  display: flex;
  align-items: start;
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
}

.merchantdrop-map-header-container {
  display: grid;
  grid-template-columns: auto auto;
}

//smaller mobile screens
@media screen and (max-width: 440px) {
  .bottom-buttons-container {
    .call-support-button {
      font-size: 18px;
      min-width: 140px;
      width: 140px;
    }
    .merchantdrop-confirm-button {
      font-size: 20px;
      min-width: 140px;
      width: 140px;
    }
    .merchantdrop-confirm-button-sub-text {
      font-size: 12px;
      width: 130px;
    }
  }
  .merchantdrop-container-main {
    padding: 56px 0 224px;
  }
}
@media screen and (max-width: 733px) {
  .merchantdrop-container-main {
    padding: 56px 0 224px;
  }
}

@media screen and (min-width: 733px) and (max-width: 961px) {
  .merchantdrop-container-main {
    padding: 136px 0 433px;

    .merchantdrop-container {
      margin: 0 59px;
    }
  }
}
//mobile
@media screen and (max-width: 961px) {
  .merchantdrop-container-main {
    background: url('../../../assets/images/graphic-bg-tracking.svg') bottom center;
    justify-content: bottom;
    background-position: center bottom;
    background-repeat: no-repeat !important;
    width: 100%;

    .merchantdrop-container {
      width: 100%;
    }

    min-height: 50vh;
  }
  .merchantdrop-map-header-container {
    grid-template-columns: auto;
  }

  .information-container {
    margin: 4px 0;
    width: 100%;
  }

  h4 {
    width: 100%;
  }

  .slot-size-container {
  }
}
//desktop
@media screen and (min-width: 961px) {
  .merchantdrop-container {
    max-width: 1320px !important;
  }
  .merchantdrop-container-main {
    padding: 146px 0 100px;
  }
}

//big screen desktop
@media screen and (min-width: 961px) and (max-width: 1500px) {
  .merchantdrop-container {
    margin-left: 64px !important;
  }
}

.font-weight-bold {
  font-weight: 700;
}

.margin-top-16 {
  margin-top: 16px;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-3-0 {
  margin: 3px 0;
}

.info-container {
  display: flex;
  align-items: start;
  margin: 6px 0;
}

.info-icon-margin {
  margin-right: 3px;
}

.margin-top-5 {
  margin-top: 5px;
}

.flex-end {
  display: flex;
  justify-content: end;
}

.min-height-300 {
  min-height: 300px;
}

.font-size-20 {
  font-size: 20px;
}

.font-size-16 {
  font-size: 16px;
}

.text-align-center {
  text-align: center;
}

.invisible {
  visibility: hidden !important;
}

.slot-size-container {
  margin: 50px 0 50px 0;
}

.phone-number-container {
  display: flex;
  align-items: center;
}

.phone-number-container strong {
  padding: 0 5px;
  display: flex;
  align-items: center;
}

.phone-number-container h3 {
  margin-right: 8px;
}

.prefix-select select {
  font-size: 16px;
  padding: 2px 5px;
  width: 100px;
}

.phone-input {
  font-size: 16px;
  padding: 2px 5px;
  margin-left: 8px;
  width: 120px;
}

.phone-number-container button {
  margin-left: 8px;
  padding: 1.5px 10px;
  font-size: 16px;
  height: auto;
  width: auto;
}

.warning-text {
  margin-top: 10px;
  color: red;
  font-size: 16px;
}
.invalid-banner {
  background-color: orange;
  color: white;
  padding: 10px;
  text-align: center;
  margin: 10px 0;
}
</style>
